<img alt="max-win" decoding="async" src="assets/images/webp/common/max-win.webp" />
<div>
  <p>{{ max_win() }}</p>
  <span class="left">✦</span>
  <span class="right">✦</span>
</div>
